import api from "./api.service";
import { API_ENDPOINTS } from "../config";

const TRANSIENT_STATUSES = new Set([408, 429, 502, 503, 504]);

// Retry only status reads; never submit another analysis while recovering.
export async function getWithRecovery(url: string, interval = 3000, retries = 100): Promise<any> {
  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      const response = await api.get<any>(url);
      if (response && !TRANSIENT_STATUSES.has(response.status)) return response;
    } catch (error: any) {
      const isNetworkError = !error.response && (
        error.isAxiosError || /network|offline|connection|fetch failed/i.test(error.message || "")
      );
      if (!isNetworkError) throw error;
    }
    if (attempt < retries) await new Promise((resolve) => setTimeout(resolve, interval));
  }
  throw new Error("Cannot reach the analysis status service yet. Your analysis may still be running. Reopen the project to check the saved result.");
}

export function getTaskStatusWithRecovery(taskId: string, interval = 3000, retries = 100) {
  return getWithRecovery(API_ENDPOINTS.TASK_STATUS_URL(taskId), interval, retries);
}
